<template>
  <div>

    <CustomModal 
      :open="open_error_modal"
      :type="'error'"
      :size="'md'"
      @close-modal="open_error_modal = false">
      <template slot="modal_content">
        <div class="error-container">
          <div v-for="(error, index) in arr_error" :key="index">
            <span>{{error}}</span>
          </div>
        </div>
      </template>
    </CustomModal>

    <CustomModal 
    :type="'success'"
    :open="open_success_modal"
    @close-modal="open_success_modal = false">
      <template slot="modal_content">
        <p class="notification-text">{{$_('success_text')}}</p>
        <p class="notification-text">{{$_('register_number')}} {{num_bon}}</p>
      </template>
    </CustomModal>

    <div class="grid-row">
      <div class="c-12">
        <h1>{{$_('sample_page_title')}}</h1>
        <p>{{$_('sample_page_text')}}</p>
      </div>
    </div>
    <div class="grid-row">
      <div class="c-12 no-gutter">
        <form @submit.prevent="vSubmitSampleForm">
          <div class="grid-row">
            <div class="c-4 c-xs-12 c-sm-12 c-md-4 c-lg-4">
              <div class="form-field no-gutter">
                <label>{{ $_('show') }} *</label>
                <Select
                  :data="aShow"
                  :placeholder="$_('your_choice')"
                  :itemoption="['TNOSAL', 'TLIB_SAL']"
                  ref="tnosal"
                  :required="true"
                  @select-change="vSetStore('tnosal', $event.item)"
                />
              </div>
            </div>
          </div>
          <div class="grid-row">
            <div class="c-1 c-xs-6 c-sm-6 c-md-1 c-lg-1">
              <div class="form-field no-gutter">
                <input
                  type="radio"
                  class="radio"
                  name="test"
                  :id="'customer_exist'"
                  v-model="form_type"
                  v-bind:value="'C'"
                />
                <label :for="'customer_exist'">{{$_('customer')}}</label>
              </div>
            </div>
            <div class="c-1 c-xs-6 c-sm-6 c-md-1 c-lg-1">
              <div class="form-field no-gutter">
                <input
                  type="radio"
                  class="radio"
                  name="test"
                  :id="'customer_new'"
                  v-model="form_type"
                  v-bind:value="'P'"
                />
                <label :for="'customer_new'">{{$_('no_customer')}}</label>
              </div>
            </div>
          </div>
          <div class="grid-row">
            <div class="c-12" v-if="form_type === 'C'">
              <FormCustomerSelect ref="FormCustomerSelect" :key="render" />
            </div>
          </div>
          <div class="grid-row">
            <div class="c-12" v-if="form_type === 'P'">
              <ProspectFormInfo ref="ProspectFormInfo" :key="render" />
            </div>
          </div>
          <div class="grid-row">
            <div class="c-12" v-if="form_type === 'P'">
              <ProspectFormDelivery ref="ProspectFormDelivery" :key="render" />
            </div>
          </div>

          <ContactList :key="render" ref="ContactList" />

          <div class="grid-row">
            <div class="c-12">
              <FormAttachment :key="render" ref="FormAttachment" />
            </div>
          </div>

          <div class="grid-row">
            <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
              <FormComment ref="FormComment" :key="render" />
            </div>
          </div>
          <div class="grid-row">
            <div class="c-12" v-if="form_type === 'P'">
              <ProspectFormCompanyInfo ref="ProspectFormCompanyInfo" />
            </div>
          </div>
          <div class="grid-row">
            <div class="c-12" v-if="form_type === 'P'">
              <ProspectFormTypologie ref="ProspectFormTypologie" />
            </div>
          </div>
          <div class="grid-row">
            <div class="c-12">
              <div class="section-general">
                <div class="grid-row">
                  <div class="c-1 no-gutter">
                    <div class="form-field">
                      <input
                        type="checkbox"
                        id="top_gratuit"
                        v-model="ttop_grat"
                        class="checkbox"
                        :checked="Boolean(ttop_grat)"
                        @change="vTopGratuit($event)"
                      />
                      <label for="top_gratuit">{{$_('free')}}</label>
                    </div>
                  </div>
                  <div class="c-2 no-gutter">
                    <div class="form-field">
                      <input
                        type="checkbox"
                        id="top_electro"
                        v-model="telectro"
                        class="checkbox"
                        @change="vTopElectro($event)"
                      />
                      <label for="top_electro">{{$_('electronic_card')}}</label>
                    </div>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12  no-gutter">
                    <FormCard :key="render" />
                  </div>
                  <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12 no-gutter">
                    <FormSample :key="render" />
                  </div>
                  <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12 no-gutter">
                    <FormRequest :key="render" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-row">
            <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
              <input type="submit" value="VALIDER" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import customerService from "@/modules/client/services/customerService";
import echantillonService from "@/modules/produit/services/echantillonService";

import Select from "@/common/components/widget/Select";
import ProspectFormInfo from "@/modules/echantillon/components/ProspectFormInfo";
import ProspectFormDelivery from "@/modules/echantillon/components/ProspectFormDelivery";
import ContactList from "@/modules/echantillon/components/ContactList";
import FormAttachment from "@/modules/echantillon/components/FormAttachment";
import ProspectFormCompanyInfo from "@/modules/echantillon/components/ProspectFormCompanyInfo";
import ProspectFormTypologie from "@/modules/echantillon/components/ProspectFormTypologie";
import FormCard from "@/modules/echantillon/components/FormCard";
import FormSample from "@/modules/echantillon/components/FormSample";
import FormRequest from "@/modules/echantillon/components/FormRequest";
import FormComment from "@/modules/echantillon/components/FormComment";
import FormCustomerSelect from "@/modules/echantillon/components/FormCustomerSelect";
import CustomModal from "@/common/components/widget/Modal/CustomModal";

export default {
  name: "SamplePage",
  data() {
    return {
      aShow: Array(),
      form_type: "P",
      ttop_grat: 0,
      telectro: 0,
      render: 0,
      arr_reference: Array(),
      error_count: 0,
      arr_error: Array(),
      open_error_modal: false,
      open_success_modal: false,
      num_bon: 0
    };
  },
  components: {
    Select,
    ProspectFormInfo,
    ProspectFormDelivery,
    ContactList,
    FormAttachment,
    ProspectFormCompanyInfo,
    ProspectFormTypologie,
    FormCard,
    FormSample,
    FormRequest,
    FormComment,
    FormCustomerSelect,
    CustomModal
  },
  created() {
    customerService.getSalon().then(res => {
      this.aShow = res.data.DS_O.OUT;
    });

    this.telectro = 1

    this.$store.dispatch("echantillon/SET_HEADER", {
      key: "telectro",
      value: 1
    });
    this.$store.dispatch("echantillon/SET_TTOP_ELECTRO", { value: 1 });
  },
  beforeUpdate() {
    this.arr_ref = Array();
  },
  updated() {
    this.arr_reference = Array();
    if (this.form_type === "P") {
      setTimeout(() => {
        this.arr_reference.push(
          this.$refs.ProspectFormInfo,
          this.$refs.ProspectFormDelivery,
          this.$refs.ProspectFormCompanyInfo,
          this.$refs.ContactList,
          this
        );
      }, 500);
    } else if (this.form_type === "C") {
      setTimeout(() => {
        this.arr_reference.push(
          this.$refs.ContactList,
          this
          );
      }, 500);
    }
  },
  computed: {
    getFormType() {
      return this.form_type;
    },
    getFormCard() {
      return this.$store.getters["echantillon/get_card"];
    },
    getFormSample() {
      return this.$store.getters["echantillon/get_sample"];
    },
    getFormContact() {
      return this.$store.getters["echantillon/get_contact"];
    },
    getFormHeader() {
      return this.$store.getters["echantillon/get_header"];
    },
    getFormAttachment() {
      return this.$store.getters["echantillon/get_attachment"];
    },
    getFormTypology() {
      return this.$store.getters['echantillon/get_typology'];
    },
    getFormSpecialRequest() {
      return this.$store.getters['echantillon/get_special_request'];
    }
  },
  watch: {
    getFormType() {
      this.$store.dispatch("echantillon/RESET");
      ++this.render;
    }
  },
  methods: {
    vSubmitSampleForm() {
      this.error_count = 0;
      this.arr_error = []

      this.arr_reference.map(ref => {

        Object.values(ref.$refs).map(ref => {

          if(Array.isArray(ref)) {
            ref.map(input => {

              if (ref !== undefined && input.required && input.currentValue !== undefined) {

                 input.activate_required = false;

                if (input.currentValue === "") {
                  input.activate_required = true;
                  ++this.error_count;
                } else {
                  // input.activate_required = false;
                  // this.error_count > 0 ? --this.error_count : 0;
                }
              }
              if (ref !== undefined && input.required && input.selected !== undefined) {

                 input.activate_required = false;

                if (Object.keys(input.selected).length === 0) {
                  input.activate_required = true;
                  ++this.error_count;
                } else {
                  // input.activate_required = false;
                  // this.error_count > 0 ? --this.error_count : 0;
                }
              }
            });
          } else {

            if (ref !== undefined && ref.required && ref.currentValue !== undefined) {

               ref.activate_required = false;

              if (ref.currentValue === "") {
                ref.activate_required = true;
                ++this.error_count;
              } else {
                // ref.activate_required = false;
                // this.error_count > 0 ? --this.error_count : 0;
              }
            }
            if (ref !== undefined && ref.required && ref.selected !== undefined) {

               ref.activate_required = false;

              if (Object.keys(ref.selected).length === 0) {
                ref.activate_required = true;
                ++this.error_count;
              } else {
                // ref.activate_required = false;
                // this.error_count > 0 ? --this.error_count : 0;
              }
            }
          }
        });
      });

      if(this.error_count === 0) {
        this.vBeforeSubmit();
      }
    },
    vBeforeSubmit() {

      if(this.getFormHeader.tcom === '' && 
          (this.getFormCard.length === 1 && this.getFormCard[0].tgenc === '') && 
          (this.getFormSample.length === 1 && this.getFormSample[0].tmod === '' ) && 
          this.getFormSpecialRequest.tds === '') {

        this.arr_error.push(this.$_('special_request_error'));
        ++this.error_count
      } else {
        // this.error_count > 0 ? --this.error_count : 0;
      }
      
      if(this.getFormSpecialRequest.tds !== '' && 
        (
          this.getFormSpecialRequest.tmailds === '') &&
          this.getFormHeader.ttop_ac === 0 &&
          this.getFormHeader.ttop_adv === 0 &&
          this.getFormHeader.ttop_cda === 0 &&
          this.getFormHeader.ttop_rdv === 0
        ) {
          this.arr_error.push(this.$_('special_request_error_info'));
          ++this.error_count
        } else {
          // this.error_count > 0 ? --this.error_count : 0;
        }

      this.vLaunch();
    },
    vLaunch() {

      let struct = Array();

      this.getFormCard.map((card, index) => {
        card.tnlig = index;
        struct.push(card);
      });

      this.getFormSample.map((sample, index) => {
        sample.tnlig = index;
        struct.push(sample);
      });

      this.getFormSpecialRequest.tnlig = 0;

      struct.push(this.getFormSpecialRequest);

      echantillonService
        .lineControl(struct)
        .then(res => {
          if (
            res.data.DS_OK.OUT2 !== undefined &&
            res.data.DS_OK.OUT2.length > 0
          ) {
            res.data.DS_OK.OUT2.map(error => {
              if (error.TCODE_ERREUR === 1 && error.TOK === 0) {
                let card_number = this.getFormCard[error.TNLIG_RET].tgenc;
                this.arr_error.push(this.$_('card_error', {card_number, error_line: (error.TNLIG_RET+1)}));
              }
            });

            res.data.DS_OK.OUT2.map(error => {
              if (error.TCODE_ERREUR === 2 && error.TOK === 0) {
                let product_number = this.getFormSample[error.TNLIG_RET].tmod;
                this.arr_error.push(this.$_('sample_error', {product_number, error_line: (error.TNLIG_RET+1)}));
              }
            });

            if (this.arr_error.length === 0) {
              echantillonService
                .sendHeader(this.getFormHeader)
                .then(res => {
                  if (
                    res.data.PNUMBON !== undefined &&
                    res.data.POK !== undefined &&
                    res.data.POK === 1
                  ) {
                    var num_bon = res.data.PNUMBON;
                    this.num_bon =  res.data.PNUMBON;

                    // console.error("====> Header OK / num bon ===> " + num_bon);

                    echantillonService
                      .sendContact(this.getFormContact, num_bon)
                      .then(res => {
                        if (res.data.POK !== undefined && res.data.POK === 1) {
                          // console.error("====> Contact OK");
                        } else {
                          this.arr_error.push(this.$_('contact_error'));
                        }
                      })
                      .catch(err => {
                        this.arr_error.push(this.$_('contact_error'));
                      });

                    echantillonService
                      .sendTypology(this.getFormTypology, num_bon)
                      .then(res => {
                        if (res.data.POK !== undefined && res.data.POK === 1) {
                          // console.error("====> Typologie OK");
                        } else {
                          this.arr_error.push(this.$_('typology_error'));
                        }
                      })
                      .catch(err => {
                        this.arr_error.push(this.$_('typology_error'));
                      });

                    if (this.getFormAttachment.length > 0) {
                      echantillonService
                        .sendFile(this.getFormAttachment, num_bon)
                        .then(res => {
                          if (res.data.length > 0) {
                            echantillonService
                              .sendFilePath(res.data, num_bon)
                              .then(response => {
                                if (response.data.POK !== undefined && response.data.POK === 1) {
                                  // console.error("====> Pièces jointes OK");
                                } else {
                                  this.arr_error.push(this.$_('attachment_error'));
                                }
                              });
                          }
                        })
                        .catch(err => {
                          this.arr_error.push(this.$_('attachment_error'));
                        });
                    }

                    echantillonService
                      .sendLines(struct, num_bon)
                      .then(res => {
                        if (res.data.POK !== undefined && res.data.POK === 1) {
                          // console.error("====> Lignes OK");
                          this.num_bon = num_bon;
                          this.open_success_modal = true;
                          this.$store.dispatch("echantillon/RESET");
                          ++this.render
                        } else {
                          this.arr_error.push(this.$_('line_error'));
                        }
                      })
                      .catch(err => {
                        this.arr_error.push(this.$_('line_error'));
                      });
                  } else {
                    this.arr_error.push(this.$_('header_error'));
                  }
                })
                .catch(err => {
                  this.arr_error.push(this.$_('header_error'));
                  this.open_error_modal = true
                });

                if (this.arr_error.length !== 0) {
                  this.open_error_modal = true
                }

            } else {
              this.open_error_modal = true
            }
          } else {
            this.arr_error.push(this.$_('lines_error'));
            this.open_error_modal = true      
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    vSetStore(key, value) {
      this.$store.dispatch("echantillon/SET_HEADER", { key, value });
    },
    vTopGratuit(event) {
      if (event.target.checked) {
        this.$store.dispatch("echantillon/SET_HEADER", {
          key: "ttop_grat",
          value: 1
        });
        this.$store.dispatch("echantillon/SET_TTOP_GRAT", { value: 1 });
      } else {
        this.$store.dispatch("echantillon/SET_HEADER", {
          key: "ttop_grat",
          value: 0
        });
        this.$store.dispatch("echantillon/SET_TTOP_GRAT", { value: 0 });
      }
    },
    vTopElectro(event) {
      if (event.target.checked) {
        this.$store.dispatch("echantillon/SET_HEADER", {
          key: "telectro",
          value: 1
        });
        this.$store.dispatch("echantillon/SET_TTOP_ELECTRO", { value: 1 });
      } else {
        this.$store.dispatch("echantillon/SET_HEADER", {
          key: "telectro",
          value: 0
        });
        this.$store.dispatch("echantillon/SET_TTOP_ELECTRO", { value: 0 });
      }
    }
  }
};
</script>

<style scoped>
.section-general {
  padding: 20px 20px 10px;
  border: solid 1px #e1e1e1;
  border-radius: 8px;
}
@media screen and (max-width: 800px) {
  
}
</style>